import * as React from "react";
import styled, { css } from "styled-components";
const Panel = styled.section(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};
    height: 100%;
  `
);
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: ${theme.spacings.sm};
  `
);
const TitleGroup = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: baseline;
    gap: ${theme.spacings.xs};
  `
);
const Title = styled.h2`
  margin: 0;
`;
const Aside = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const TitleDetail = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    font-family: ${theme.fonts.family.body};
    font-size: ${theme.fonts.size.body};
  `
);
const UsageSection = ({ title, detail = void 0, aside = void 0, children = void 0 }) => /* @__PURE__ */ React.createElement(Panel, { "aria-label": title }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(TitleGroup, null, /* @__PURE__ */ React.createElement(Title, null, title), detail && /* @__PURE__ */ React.createElement(TitleDetail, null, "\xB7 ", detail)), aside && /* @__PURE__ */ React.createElement(Aside, null, aside)), children);
export default UsageSection;
